import Modal from "components/Modal/Modal";
import {
  selectState,
  setCalculationPrintModalOpen,
  closeCalculationModals,
} from "../payroll.slice";
import { useSelector } from "react-redux";
import { useAppDispatch } from "hooks/hooks";
import { useEffect, useRef, useState } from "react";
import PrintSalaries from "./PrintSalaries";
import { usePagePrint } from "hooks/usePagePrint";
import { monthNames } from "utils/translationDictionary";
import { IPayrollsForPrintResponse } from "Dashboard/scenes/HumanResources/domain/IPayrollsForPrintResponse";
import { hrService } from "Dashboard/scenes/HumanResources/services/hr.services";
import Loader from "components/Loader/Loader";

interface IProps {
  handlePrintAdmin: any;
  selectedMonth: number;
  selectedYear: number;
}

const CalculationPrintModal = ({
  handlePrintAdmin,
  selectedMonth,
  selectedYear
}: IProps) => {
  const { calculationPrintModalOpen } = useSelector(selectState);
  const dispatch = useAppDispatch();

  const [payrolls, setPayroll] = useState<IPayrollsForPrintResponse | undefined>(undefined);

  useEffect(() => {
    setPayroll(undefined);
    hrService
      .getAllPayrollsForPrint({
        year: selectedYear, month: selectedMonth
      })
      .then((payrolls) => {
        setPayroll(payrolls);
      });
  }, [selectedYear, selectedMonth]);


  const componentRef = useRef<HTMLDivElement>(null);
  const handlePrint = usePagePrint(componentRef, { margins: "0.5cm" });

  const close = () => {
    dispatch(setCalculationPrintModalOpen(false));
  };

  const printAdmin = () => {
    dispatch(closeCalculationModals());
    handlePrintAdmin();
  };

  const print = () => {
    dispatch(closeCalculationModals());
    handlePrint();
  };

  return (
    <Modal
      isOpen={calculationPrintModalOpen}
      onClose={close}
      onClick={payrolls !== undefined ? print : undefined}
      onClick1={false ? printAdmin : undefined}
      txtField="Št. Admin"
    >
      <div className="print-modal-content">
        {payrolls === undefined && <Loader />}
        <p className="msg">
          Štampaj listu obračuna plata svih radnika za dati mesec i godinu.
        </p>
        <div className="selections">
          <div>
            <label>Mesec:</label>
            <span>{monthNames[selectedMonth - 1]}</span>
          </div>
          <div>
            <label>Godina:</label>
            <span>{selectedYear}</span>
          </div>
        </div>
      </div>
      <div ref={componentRef} className="print-area">
        <PrintSalaries
          year={selectedYear}
          month={selectedMonth}
          payrolls={payrolls}
        />
      </div>
    </Modal>
  );
};

export default CalculationPrintModal;
